module.exports = __webpack_public_path__ + "static/media/Dropcap_Logo_003.d7bb510f.jpg";